import { yup } from "@swa-ui/object";

import { getLocationDataSchema } from "./getLocationDataSchema";

let schema;

export const getGeolocationSchema = () => {
  if (!schema) {
    schema = yup.object().shape({
      countryCode: yup.string(),
      GDPR: yup.boolean(),
      isInternationalStation: yup.boolean(),
      locationData: getLocationDataSchema(),
      nearestStation: yup.string(),
    });
  }

  return schema;
};
